import noop from 'lodash/noop';
import { createContext } from 'react';

import type { useSnackbar } from './hooks';

export const context = createContext<ReturnType<typeof useSnackbar>>({
  open: null,
  onOpen: noop,
  onClose: noop,
  isFeedbackOpened: false,
  isDeletingOpened: false,
});

export const { Provider } = context;
